const suppressFaculty = {
    // Suppress for all meetings
    all: [11642, 9204],
    // Fellows 2023
    200: [],
}

export default suppressFaculty
